import { createContext, useContext, useRef, useState, useCallback, useEffect } from "react";
import { createRitualAudio } from "@/lib/ritualAudio";

const AmbientAudioContext = createContext(null);

export const AmbientAudioProvider = ({ children }) => {
  const engineRef = useRef(null);
  const [started, setStarted] = useState(false);
  const [muted, setMuted] = useState(false);

  const ensureEngine = () => {
    if (!engineRef.current) engineRef.current = createRitualAudio();
    return engineRef.current;
  };

  const start = useCallback(async () => {
    const eng = ensureEngine();
    await eng.start();
    eng.setMuted(false);
    setStarted(true);
    setMuted(false);
  }, []);

  const toggleMute = useCallback(() => {
    const eng = engineRef.current;
    if (!eng) return;
    const next = !muted;
    eng.setMuted(next);
    setMuted(next);
  }, [muted]);

  const setMode = useCallback((mode) => {
    const eng = engineRef.current;
    if (eng && eng.setMode) eng.setMode(mode);
  }, []);

  useEffect(() => {
    return () => {
      if (engineRef.current) engineRef.current.stop();
    };
  }, []);

  return (
    <AmbientAudioContext.Provider value={{ started, muted, start, toggleMute, setMode }}>
      {children}
    </AmbientAudioContext.Provider>
  );
};

export const useAmbientAudio = () => useContext(AmbientAudioContext);
